import { render, staticRenderFns } from "./BaseSelect.vue?vue&type=template&id=debb8ff8&"
import script from "./BaseSelect.vue?vue&type=script&lang=js&"
export * from "./BaseSelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelect.vue?vue&type=style&index=0&id=debb8ff8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports